// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active {
  border-radius: 12px;
  border: 1px solid var(--Grey-10, #F3F3F3);
  background: var(--White, #FDFDFD);
  cursor: pointer;
}

.ticketContainer .disabled {
  border-radius: 12px;
  background: var(--Grey-10, #F3F3F3);
  cursor: not-allowed;
}

.active:hover {
  background: #F8F8F8;
}

.bd-1 {
  border-radius: 7.714px;
  border: 0.643px solid var(--Grey-30, #E7E7E7);
  background: var(--White, #FDFDFD);
  /* Shadow/xs */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.bd-2 {
  border-radius: 12px;
  border: 1px solid var(--Grey-10, #F3F3F3);
}

.ticketCardHeading {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 135%;
}

.ticketProfile {
  width: 48px;
  height: 48px;
  border-radius: 8.348px;
  box-shadow: 0px 1.043px 2.087px 0px rgba(16, 24, 40, 0.05);
}

.ticket-avatar {
  height: 48px !important;
  width: 48px !important;
}

.alertLabel {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.confirm-modal .modal-container {
  display: flex;
  width: 480px !important;
  height: 356px !important;
  flex-direction: column;
  align-items: flex-start;
  gap: 0 !important;
}
.confirm-modal .modal-header {
  width: 100% !important;
}
.confirm-modal .modal-content {
  padding-top: 0 !important;
}

.chk-active .checkbox-select {
  background-color: #FF2459 !important;
  border: 1px solid #FF2459 !important;
}

.booking-success button {
  width: 100% !important;
}

.community-btn {
  padding: 20px !important;
}

@media screen and (max-width: 650px) {
  .ticketCardHeading {
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: 125% !important;
  }
  .alertLabel {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
  }
  .ticketListContainer {
    gap: 36px !important;
    width: 100% !important;
    padding: 24px !important;
    margin-top: 10px !important;
  }
  .ticket-avatar {
    height: 36px !important;
    width: 36px !important;
  }
  .ticketNameContainer {
    gap: 16px !important;
  }
  .ticketName {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 2px !important;
    flex: 1 0 0 !important;
  }
  .hd {
    font-size: 12px !important;
  }
  .confirm-modal .modal-container {
    display: flex;
    width: 327px !important;
    height: 414px !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 0 !important;
    padding: 0 !important;
  }
  .confirm-modal .modal-header {
    width: 100% !important;
    font-size: 16px !important;
    padding-bottom: 12px !important;
  }
  .confirm-modal .modal-content {
    padding-top: 0 !important;
  }
  .community-btn {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/buyer-flow/components/style.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yCAAA;EACA,iCAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,mCAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,6CAAA;EACA,iCAAA;EAEA,cAAA;EACA,kDAAA;AAAF;;AAGA;EACE,mBAAA;EACA,yCAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0DAAA;AAAF;;AAGA;EACE,uBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAIE;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AADJ;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;;AASE;EACE,oCAAA;EACA,oCAAA;AANJ;;AAWE;EACE,sBAAA;AARJ;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE;IACE,0BAAA;IACA,kBAAA;IACA,2BAAA;IACA,4BAAA;EARF;EAWA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EATF;EAYA;IACE,oBAAA;IACA,sBAAA;IACA,wBAAA;IACA,2BAAA;EAVF;EAaA;IACE,uBAAA;IACA,sBAAA;EAXF;EAcA;IACE,oBAAA;EAZF;EAeA;IACE,sBAAA;IACA,kCAAA;IACA,mBAAA;IACA,sBAAA;EAbF;EAgBA;IACE,0BAAA;EAdF;EAkBE;IACE,aAAA;IACA,uBAAA;IACA,wBAAA;IACA,sBAAA;IACA,uBAAA;IACA,iBAAA;IACA,qBAAA;EAhBJ;EAmBE;IACE,sBAAA;IACA,0BAAA;IACA,+BAAA;EAjBJ;EAoBE;IACE,yBAAA;EAlBJ;EAsBA;IACE,sBAAA;EApBF;AACF","sourcesContent":[".active{\n  border-radius: 12px;\n  border: 1px solid var(--Grey-10, #F3F3F3);\n  background: var(--White, #FDFDFD);\n  cursor: pointer;\n}\n\n.ticketContainer .disabled{\n  border-radius: 12px;\n  background: var(--Grey-10, #F3F3F3);\n  cursor: not-allowed;\n}\n\n.active:hover{\n  background: #F8F8F8;\n}\n\n.bd-1{\n  border-radius: 7.714px;\n  border: 0.643px solid var(--Grey-30, #E7E7E7);\n  background: var(--White, #FDFDFD);\n  \n  /* Shadow/xs */\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.bd-2{\n  border-radius: 12px;\n  border: 1px solid var(--Grey-10, #F3F3F3);\n}\n\n.ticketCardHeading{\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 135%;\n}\n\n.ticketProfile{\n  width: 48px;\n  height: 48px;\n  border-radius: 8.348px;\n  box-shadow: 0px 1.043px 2.087px 0px rgba(16, 24, 40, 0.05);\n}\n\n.ticket-avatar {\n  height: 48px !important;\n  width: 48px !important;\n}\n\n.alertLabel{\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.confirm-modal{\n  .modal-container{\n    display: flex;\n    width: 480px !important;\n    height: 356px !important;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0 !important;\n  }\n\n  .modal-header{\n    width: 100% !important;\n  }\n\n  .modal-content{\n    padding-top: 0 !important;\n  }\n}\n\n.chk-active{\n\n  .checkbox-select {\n    background-color: #FF2459 !important;\n    border: 1px solid #FF2459 !important;\n  }\n}\n\n.booking-success {\n  button{\n    width: 100% !important;\n  }\n}\n.community-btn {\n  padding: 20px !important;\n}\n\n@media screen and (max-width: 650px) {\n  .ticketCardHeading{\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 600 !important;\n    line-height: 125% !important;\n  }\n\n  .alertLabel{\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%;\n  }\n\n  .ticketListContainer{\n    gap:36px !important;\n    width: 100% !important;\n    padding:24px !important;\n    margin-top: 10px !important;\n  }\n\n  .ticket-avatar {\n    height: 36px !important;\n    width: 36px !important;\n  }\n\n  .ticketNameContainer{\n    gap:16px !important;\n  }\n\n  .ticketName{\n    flex-direction: column;\n    align-items: flex-start !important;\n    gap: 2px !important;\n    flex: 1 0 0 !important;\n  }\n\n  .hd{\n    font-size: 12px !important;\n  }\n\n  .confirm-modal{\n    .modal-container{\n      display: flex;\n      width: 327px !important;\n      height: 414px !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0 !important;\n      padding: 0 !important;\n    }\n  \n    .modal-header{\n      width: 100% !important;\n      font-size: 16px !important;\n      padding-bottom: 12px !important;\n    }\n  \n    .modal-content{\n      padding-top: 0 !important;\n    }\n\n  }\n  .community-btn{\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
